const STAKEHOLDER_TYPE = {
  CPO: 'cpo',
  OWNER: 'owner',
  MUNICIPALITY: 'municipality',
}

module.exports = {
  STAKEHOLDER_TYPE,
}
